import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import each from './each';

function assign(target, ...sources) {
  Object.assign(target, ...sources);
  return target;
}

function deep(target, ...sources) {
  each(sources, (source) => {
    each(source, (v, k) => {
      if (isArray(v)) {
        target[k] = isArray(target[k]) ? target[k] : [];
        deep(target[k], v);
        return;
      }
      if (isPlainObject(v)) {
        target[k] = isPlainObject(target[k]) ? target[k] : {};
        deep(target[k], v);
        return;
      }
      target[k] = v;
    });
  });
  return target;
}

assign.deep = deep;

export default assign;



// WEBPACK FOOTER //
// ../x/packages/util/src/assign.js